import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { environment } from "environments/environment";
import { UnAuthService } from "app-modules/core/store/un-auth/un-auth.service";
import { BusinessRulesService } from "app-modules/core/store/business-rules/business-rules.service";
import { Subscription } from "rxjs";
import { IListInfo } from "app-modules/core/store/models/list-info-state.interface";
import { BusinessRuleInfo, BusinessRuleType } from "emr-ng-shared";
import { APP_IN_CHINA } from "base/regionFinder";
import { NgIf } from "@angular/common";

@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.css"],
  standalone: true,
  imports: [NgIf]
})
export class BannerComponent implements OnInit, OnDestroy {
  isShowBanner = false;
  isAppInChina: boolean = false;
  businessRuleSubscription: Subscription;
  constructor(private _businessRulesService: BusinessRulesService,
    @Inject(APP_IN_CHINA) appInChina: boolean) {
    this.isAppInChina = appInChina;
  }

  ngOnInit(): void {
    this.businessRuleSubscription =
      this._businessRulesService.businessRulesList$.subscribe(
        (rules: IListInfo<BusinessRuleInfo>) => {
          this.isShowBanner = !this.isAppInChina && rules.list.some(
            (k) =>
              k.BusinessRuleTypeCode == BusinessRuleType.Display360Rollout &&
              k.Enabled
          );
          if (this.isShowBanner) {
            document.querySelector("body").style.cssText = "";
          } else {
            document.querySelector("body").style.cssText =
              "--banner-height: 0px; --total-header-height: 40px";
          }
        }
      );
  }

  ngOnDestroy(): void {
    this.businessRuleSubscription?.unsubscribe();
  }

  OnCloseButtonClick() {
    this.isShowBanner = false;
    localStorage.setItem(environment.showBanner, this.isShowBanner.toString());
    document.querySelector("body").style.cssText =
      "--banner-height: 0px; --total-header-height: 40px";
  }
}
